import React from 'react';
import { Chip } from 'react-native-paper';
import { MaterialIcons } from '@expo/vector-icons';

interface FilterChipProps {
  label: string;
  selected: boolean;
  onPress: () => void;
  size?: 'small' | 'medium' | 'large';
}

const FilterChip: React.FC<FilterChipProps> = ({ 
  label, 
  selected, 
  onPress, 
  size = 'medium' 
}) => {
  const getTextStyle = () => {
    switch (size) {
      case 'small':
        return { fontSize: 11 };
      case 'large':
        return { fontSize: 14, fontWeight: 'bold' };
      default:
        return { fontSize: 12 };
    }
  };

  return (
    <Chip
      style={{
        marginRight: 4,
        marginBottom: 4,
        backgroundColor: selected ? '#FCD34D' : '#FEF3C7',
        borderColor: '#F59E0B',
        borderWidth: 1,
      }}
      textStyle={{
        ...getTextStyle(),
        color: '#92400E',
      }}
      mode="outlined"
      onPress={onPress}
      selected={selected}
      icon={selected ? () => <MaterialIcons name="check" size={16} color="#10B981" /> : undefined}
    >
      {label}
    </Chip>
  );
};

export default FilterChip;
